// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XnhNf{transition:opacity 150ms ease-in-out}.XnhNf.R0nCe{opacity:.55}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"thumb": `XnhNf`,
	"thumbDimmed": `R0nCe`
};
export default ___CSS_LOADER_EXPORT___;
